import VideoJsAdapter from '@javascripts/adapters/videojs_adapter';
import Button from '../../button';
import NextButtonPanel from './panel';
import NextVideoService from '@javascripts/service/next_video/service';
import LocationAdapter from '@javascripts/adapters/location_adapter';
import { sendClickEvent } from '@javascripts/service/next_video/tracker';

export default class Index extends Button {
  constructor(player, options = {}) {
    super(player, options);
    this.checkAndRequestNextVideoData();
  }

  buildCSSClass() {
    return `vjs-next-button ${super.buildCSSClass()}`;
  }

  checkAndRequestNextVideoData() {
    if (NextVideoService.dataIsExists()) {
      this.activateButton();
      this.buildPanel();
    } else {
      NextVideoService.request(this.options_.videoId, this.onRequestDataComplete.bind(this));
    }
  }

  onRequestDataComplete(success) {
    if (!success) return;

    this.activateButton();
    this.buildPanel();
  }

  activateButton() {
    // in rare cases el() can return null
    if (this.el()) {
      this.el().classList.add('vjs-next-button--active');
    }
  }

  buildPanel() {
    let container = document.createElement('div');
    container.className = 'vjs-next-button__panel';

    let nextVideoData = NextVideoService.data();
    let filmTitle = nextVideoData.film_title ? nextVideoData.film_title : "";
    container.innerHTML = NextButtonPanel.html(nextVideoData.title, filmTitle, nextVideoData.image_url);

    // in rare cases el() can return null
    if (this.el()) {
      this.el().appendChild(container);
    }
  }

  handleClick() {
    if (!NextVideoService.dataIsExists()) return;

    sendClickEvent(NextVideoService.data().id, 'next-video-button', this.options().videoId);
    LocationAdapter.href(NextVideoService.watchpageUrl());
  }
}

Index.prototype.controlText_ = "Next";
VideoJsAdapter.registerComponent('VpNextButton', Index);
